import React, { FC } from 'react'
import styled from 'styled-components'
import { Box, breakpoints, CleanButton } from '@gassan-ui'
import { MarginBottomProps } from 'styled-system'

export const Dash = styled.span<{ active: boolean }>`
  display: block;
  height: 0.25rem;
  width: 2.5rem;
  background: ${p => (p.active ? p.theme.rolex.colors.primary : p.theme.rolex.colors.shades[300])};
  grid-row: 1;
  border-radius: 0.25rem;
  outline: 0;
  transition: background 0.2s ease-in-out;

  @media screen and (min-width: ${breakpoints.small}) {
    width: 5rem;
  }
`

type Props = MarginBottomProps & {
  activeIndex: number
  count: number
  onClick: (index: number) => void
}

const Indicators: FC<Props> = ({ activeIndex, count, onClick, mb = '1.875rem' }) => (
  <Box
    display="grid"
    gridAutoFlow="column"
    gridColumnGap={['0.5rem', '1.25rem']}
    as="nav"
    justifyContent="center"
    mb={mb}
    mt="-0.5rem"
  >
    {Array.from(new Array(count)).map((_, index) => {
      return (
        <CleanButton key={index} onClick={() => onClick(index)} py="0.5rem">
          <Dash active={activeIndex === index} />
        </CleanButton>
      )
    })}
  </Box>
)

export default Indicators
